import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "\n      bg-white\n      flex flex-col\n      text-12px\n      xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      font-montserrat\n    " }
const _hoisted_2 = { class: "flex flex-row text-12px xxl:text-14px items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "\n            font-semibold\n            text-20px\n            mr-8\n            whitespace-nowrap\n            text-black-lp-200\n            capitalize\n          " }, " Konfigurasi Kargo ", -1)
const _hoisted_4 = { class: "w-3/4" }
const _hoisted_5 = {
  key: 1,
  class: "overflow-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectCity = _resolveComponent("SelectCity")!
  const _component_advance_filter_cargo_configuration = _resolveComponent("advance-filter-cargo-configuration")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_delete_config_popup = _resolveComponent("delete-config-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Header, null, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_SelectCity, {
              placeholder: "Ketik atau pilih lokasi asal",
              modelValue: _ctx.filterData.origin,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterData.origin = $event)),
              class: "mx-2",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangePagination(1)))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_SelectCity, {
              placeholder: "Ketik atau pilih lokasi tujuan",
              modelValue: _ctx.filterData.destination,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterData.destination = $event)),
              class: "mx-2",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangePagination(1)))
            }, null, 8, ["modelValue"]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_advance_filter_cargo_configuration)
            ])
          ]),
          (_ctx.isCreateAble)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                title: "Buat Konfig",
                textColor: "white",
                textSize: 10,
                class: "ml-6 ",
                customClass: "whitespace-nowrap",
                onClick: _ctx.goToCreate
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.dataCargoConfig.length && _ctx.firstRequest && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            data: "Konfigurasi Kargo"
          }))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_TableV2, {
              loading: _ctx.isLoading,
              borderTop: false,
              borderBottom: false,
              columns: _ctx.columns,
              data: _ctx.dataCargoConfig,
              class: "my-2",
              onClick: _ctx.onClickRow,
              isDetailAble: _ctx.isDetailAble,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => (_ctx.pagination = $event)),
              onRequest: _ctx.fetchListCargoConfig,
              onTryAgain: _ctx.fetchListCargoConfig,
              paginationStyle: "v3",
              isRightFreeze: "",
              totalColumnFreeze: 2,
              groupAction: ""
            }, null, 8, ["loading", "columns", "data", "onClick", "isDetailAble", "pagination", "onRequest", "onTryAgain"])
          ]))
    ]),
    (_ctx.deleteConfigModal)
      ? (_openBlock(), _createBlock(_component_delete_config_popup, _mergeProps({
          key: 0,
          onFinish: _ctx.fetchListCargoConfig,
          modelValue: _ctx.deleteConfigModal,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteConfigModal = $event))
        }, _ctx.configSelected), null, 16, ["onFinish", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}